import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './DAcDashboard.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, getDictionaryItem } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import DashboardTable from './components/DashboardTable/DashboardTable';
import { IconNewApp } from './components/icons/newapp';
import { IconMiniWarning } from '../atoms/Icons';
import InjectHTML from '../DAcCreateAccount/components/InjectHTML';
var DAcDashboard = function DAcDashboard(props) {
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var fields = props.fields,
    params = props.params;
  var _fields$data = fields.data,
    configuration = _fields$data.configuration,
    dictionary = _fields$data.dictionary,
    settings = _fields$data.settings;
  var newApplicationLink = get(configuration, 'buttonApplicationNewUrl.jss.value.href');
  var _React$useState = React.useState({
      available: 0,
      existing: 0
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    appStatus = _React$useState2[0],
    setAppStatus = _React$useState2[1];
  var applicantsMessage = getDictionaryItem(dictionary, 'applicationsLeftMessage');
  var formatApplicantsMessage = function formatApplicantsMessage(available, members) {
    return applicantsMessage.replace('$available$', available).replace('$members$', members);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "dac-dashboard"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "dac-dashboard__title"
  }, get(configuration, 'dashboardTitle.jss.value'))), appStatus.available - appStatus.existing > 0 && /*#__PURE__*/React.createElement("div", {
    className: "col-5 col-lg-3 d-none d-md-flex"
  }, /*#__PURE__*/React.createElement("a", {
    href: newApplicationLink,
    className: "btn btn-primary dac-dashboard__start-new ml-md-auto"
  }, /*#__PURE__*/React.createElement(IconNewApp, null), getDictionaryItem(dictionary, 'startANewApplications')))), applicantsMessage && appStatus.available - 1 > 0 && /*#__PURE__*/React.createElement("div", {
    className: "dashboard-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-info__icon"
  }, /*#__PURE__*/React.createElement(IconMiniWarning, null)), /*#__PURE__*/React.createElement("div", {
    className: "dashboard-info__text"
  }, /*#__PURE__*/React.createElement(InjectHTML, {
    htmlString: formatApplicantsMessage("".concat(appStatus.available - appStatus.existing, "/").concat(appStatus.available), String(appStatus.available - 1))
  }))), /*#__PURE__*/React.createElement(DashboardTable, {
    configuration: configuration,
    dictionary: dictionary,
    settings: settings,
    getAppStatus: setAppStatus
  }), appStatus.available - appStatus.existing > 0 && /*#__PURE__*/React.createElement("a", {
    href: newApplicationLink,
    className: "btn btn-primary dac-dashboard__start-new d-inline-flex d-md-none mt-4"
  }, /*#__PURE__*/React.createElement(IconNewApp, null), getDictionaryItem(dictionary, 'startANewApplications'))));
};
var StyledWrapper = function StyledWrapper(_ref) {
  var children = _ref.children,
    rtl = _ref.rtl,
    anchorUrlParameter = _ref.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
export default DAcDashboard;
var commonStyles = "cz9jd1k";
var ltrStyles = "l3g7xa3";
var rtlStyles = "rt5svmu";